import React from 'react';
import { testimonialsSection, testimonials } from '../data/mock';
import { Star } from 'lucide-react';

const TestimonialCard = ({ testimonial }) => {
  const stars = [1, 2, 3, 4, 5];
  
  return (
    <div className="bg-[#faf9f7] rounded-lg p-6 md:p-8">
      {/* Quote Mark */}
      <div className="text-[#d8d5d0] text-4xl mb-4" style={{ fontFamily: "Georgia, serif" }}>
        "
      </div>
      
      {/* Stars */}
      <div className="flex gap-1 mb-4">
        {stars.slice(0, testimonial.rating).map((star) => (
          <Star 
            key={star} 
            className="w-5 h-5 fill-[#c4a77d] text-[#c4a77d]" 
          />
        ))}
      </div>
      
      {/* Text */}
      <p 
        className="text-[#3a3a3a] text-lg md:text-xl leading-relaxed mb-6 italic"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        "{testimonial.text}"
      </p>
      
      {/* Author */}
      <div>
        <p 
          className="text-[#3a3a3a] text-lg font-medium"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {testimonial.author}
        </p>
        <p 
          className="text-[#6b6b6b] text-sm"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {testimonial.service}
        </p>
      </div>
    </div>
  );
};

const TestimonialsSection = () => {
  return (
    <section className="bg-[#f5f3ef] py-16 md:py-24 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p 
            className="text-[#5a6b4e] text-lg md:text-xl mb-3 italic"
            style={{ fontFamily: "'Pinyon Script', cursive" }}
          >
            {testimonialsSection.subtitle}
          </p>
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl text-[#3a3a3a]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {testimonialsSection.title}
          </h2>
        </div>
        
        {/* Testimonials Grid */}
        <div className="space-y-6">
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
